import {IPasswordStrength, PasswordField} from "components/widgets/PasswordField";
import * as React from "react";
import {useState} from "react";
import {ButtonAction} from "components/widgets/ButtonAction";
import {FormElement} from "../shared/FormElement";
import {UserAvatarEditor} from "components/account/widgets/UserAvatarEditor";

import './CreateAccountPanel.pcss';
import {UIStateVendor} from "data/UIStateVendor";
import {ICreateAccountData} from "data/UserDataSource";
import * as EmailValidator from "email-validator";

interface Props {

}

export const CreateAccountPanel = (props:Props) => {
  const [firstName, setFirstName] = useState('');
  const [firstNameInvalidReason, setFirstNameInvalidReason] = useState('');

  const [lastName, setLastName] = useState('');
  const [lastNameInvalidReason, setLastNameInvalidReason] = useState('');

  const [professionalTitle, setProfessionalTitle] = useState('');
  const [professionalTitleInvalidReason, setProfessionalTitleInvalidReason] = useState('');

  const [company, setCompany] = useState('');
  const [companyInvalidReason, setCompanyInvalidReason] = useState('');

  const [email, setEmail] = useState('');
  const [emailInvalidReason, setEmailInvalidReason] = useState('');

  const [password, setPassword] = useState('');
  const [passwordStrength, setPasswordStrength] = useState<IPasswordStrength|null>(null);
  const [passwordInvalidReason, setPasswordInvalidReason] = useState('');
  const [pleaseWait, setPleaseWait] = useState(false);

  const [avatarBlobData, setAvatarBlobData] = useState<any>();

  function emptyOrTooShort(val:string, min:number=1) {
    return !val || val.trim().length < min;
  }

  function createAccount() {

    let preventCreateAccount = false;
    // Validations
    if(emptyOrTooShort(firstName)) {
      setFirstNameInvalidReason("First name is required.");
      preventCreateAccount = true;
    } else {
      setFirstNameInvalidReason('');
    }

    if(emptyOrTooShort(lastName)) {
      setLastNameInvalidReason("Last name is required.");
      preventCreateAccount = true;
    } else {
      setLastNameInvalidReason('');
    }

    if(emptyOrTooShort(professionalTitle)) {
      setProfessionalTitleInvalidReason("Title is required.");
      preventCreateAccount = true;
    } else {
      setProfessionalTitleInvalidReason('');
    }

    if(emptyOrTooShort(company)) {
      setCompanyInvalidReason("Company is required.");
      preventCreateAccount = true;
    } else {
      setCompanyInvalidReason('');
    }

    if(emptyOrTooShort(email)) {
      setEmailInvalidReason("Email is required for sign in.");
      preventCreateAccount = true;
    } else if(!EmailValidator.validate(email)) {
      setEmailInvalidReason("A valid Email is required for sign in.");
      preventCreateAccount = true;
    } else {
      setEmailInvalidReason('');
    }

    if(emptyOrTooShort(password) || null==passwordStrength || passwordStrength.id<2) {
      setPasswordInvalidReason('Your password is not strong enough and it must be 8 or more characters long and contain at least 3 of the following: an uppercase letter, a lowercase letter, a special character, and a number.');
      preventCreateAccount = true;
    } else {
      setPasswordInvalidReason('');
    }

    // Create a vendor account
    if(!preventCreateAccount) {
      const data: ICreateAccountData = {
        firstName: firstName,
        lastName: lastName,
        professionalTitle: professionalTitle,
        company: company,
        email: email,
        password: password,
        employeeOrSpouse: '',
        spouseName: '',
        locationId: '',
        employeeId: '',
        extra: '',
      }

      UIStateVendor.createVendorAccount(data, avatarBlobData)
      .then(() => {
        console.log('successfully created a new account');
      })
      .catch((reason) => {
        console.log(reason);
        UIStateVendor.alert('Failed to create an account! '+reason);
      });

    } else {
      alert('All fields are required and must be valid. Please address the problems displayed before continuing.');
    }

  }



  return (
      <div className={"create-account"}>
        <h2 className={'level2'}>Create Account</h2>
        <p>All fields are required.</p>

        <FormElement label={'First Name'} invalidReason={firstNameInvalidReason} disabled={pleaseWait} value={firstName} onChange={setFirstName} />
        <FormElement label={'Last Name'} invalidReason={lastNameInvalidReason} disabled={pleaseWait} value={lastName} onChange={setLastName} />
        <FormElement label={'Title'} invalidReason={professionalTitleInvalidReason} disabled={pleaseWait} value={professionalTitle} onChange={setProfessionalTitle} />
        <FormElement label={'Company'} invalidReason={companyInvalidReason} disabled={pleaseWait} value={company} onChange={setCompany} />
        <div className={"form-element"}>
          <label>Your Photo</label>
          <div>
            <UserAvatarEditor
                existingAvatarURL={''}
                setData={setAvatarBlobData}
                hideTitleAndDescription
            />
          </div>
        </div>

        <FormElement label={'Email'} invalidReason={emailInvalidReason} disabled={pleaseWait} value={email} onChange={setEmail} />

        <div className={`form-element${passwordInvalidReason?' invalid':''}`}>
          <label htmlFor={'password'}>Password</label>
          <p id={'password-desc'} className={passwordInvalidReason?'form-element-error':''}>{passwordInvalidReason ? passwordInvalidReason : 'Must be 8 or more characters long and contain at least 3 of the following: an uppercase letter, a lowercase letter, a special character, and a number.'}</p>
          <PasswordField
              id="password"
              aria-describedby={'password-desc'}
              required
              invalid={!!passwordInvalidReason}
              error={!!passwordInvalidReason}
              inputName="password"
              password={password}
              onPasswordChange={(p, passwordStrength)=>{
                setPassword(p);
                setPasswordStrength(passwordStrength);
              }}
              email={email}
              firstName={firstName}
              lastName={lastName}
          />
        </div>

        <ButtonAction buttonActionIsBroken onClick={createAccount} className={"cta-button noselect"}>{pleaseWait ? "Please Wait" : "Create Account"}</ButtonAction>

      </div>
  )
}